import { useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const SharedCartLoader = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const loaded = useRef(false);

  useEffect(() => {
    const cartCode = searchParams.get("cart");
    if (!cartCode || loaded.current) return;
    loaded.current = true;

    // Redirect to the shared cart page
    searchParams.delete("cart");
    setSearchParams(searchParams, { replace: true });
    navigate(`/סל-משותף/${cartCode}`, { replace: true });
  }, [searchParams]);

  return null;
};

export default SharedCartLoader;
